// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","pageTitle":"_35lfLH2rb4Z314OGFun3T2","noContentMsg":"_1xNbTw90-mkCudW9YoFyzY"};